import gql from 'graphql-tag';

const query = gql`
  query UserData($date: Date!) {
    me {
      id
      sex
      email
      name
      systemOfMeasures
      systemOfMeasuresNutrition
      created
      diet {
        id
        accessTo
      }
      videoWorkout {
        accessTo
      }
      aiAccess {
        hasAccess
      }
    }
    dailyTracker {
      data(date: $date) {
        date
        baseCalories
      }
    }
  }
`;

export default query;
